export default {
    parts: [],
    baseStyle: (props) => ({
        sectionTitle: {
            fontSize: {base: 'md', lg: 'xs'},
            lineHeight: {lg: '15px'},
            letterSpacing: {lg: '0'},
            color: {lg: 'grey.700'},
            fontWeight: {lg: 'medium'},
            mb: {lg: 4}
        },
        linkContainer: {
            lineHeight: {lg: '15px'}
        },
        footerLink: {
            display: {base: 'inline-block'},
            fontSize: {base: 'sm', lg: 'xs'},
            lineHeight: {base: '18px', lg: '15px'},
            letterSpacing: {lg: '0'},
            fontWeight: {lg: 'medium'},
            marginTop: {base: 3, lg: 0},
            marginBottom: {base: 3, lg: 2}
        },
        accordionItem: {
            border: {base: '0'}
        },
        accordionButton: {
            fontSize: {base: 'sm'},
            fontWeight: {base: 'medium'},
            lineHeight: {base: '100%'},
            letterSpacing: {base: '0px'},
            paddingTop: {base: '17px'},
            paddingBottom: {base: '17px'},
            justifyContent: {base: 'space-between'}
        },
        accordionIcon: {
            transition: {base: 'transform 0.2s ease-in-out'},
            width: {base: '14px'},
            height: {base: '14px'},
            ...(props.isExpanded ? {
                transform: 'rotate(180deg)'
            } : {
                transform: 'rotate(0deg)'
            })
        },
        accordionPanel: {
            padding: {base: 0}
        },
        accordionPanelExpanded: {
            paddingTop: {base: 0},
            paddingRight: {base: 0},
            paddingBottom: {base: 6},
            paddingLeft: {base: 0}
        }
    })
}
